import { GetBannerDetailsRequest } from './getbannerdetailsrequest';
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../../api';

export class GetBannerDetailsAPI extends APIImpl<GetBannerDetailsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-banner-details
        return "get-banner-details";
    }

    getRequestData()
    {
        return "clientTxnId="+ this.getRequest().getGetBannerRequest().getClientTxnId()+"&"+
               "identifier="+ this.getRequest().getGetBannerRequest().getIdentifier()+"&"+
               "bannerOrder="+ this.getRequest().getGetBannerRequest().getBannerOrder()+"&"+
               "bannerType="+ this.getRequest().getGetBannerRequest().getBannerType();
    }
}
//Type of Banner.  4 for English Pre booking, 5 for Arabic Pre booking, 3 for English Manual, 6 for Arabic Manual



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getbannerdetails/getbannerdetailsapi.tsx